module.exports = __webpack_public_path__ + "img/feature-1-arizona-mobile.585819e9.png";